import React from 'react';

const Success = () => {
  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <h1 id='nodeText'>Submitted successfully</h1>
      <div>
        <span>
          We will process your request immediately after receiving the recharge
        </span>
      </div>
    </div>
  );
};

export default Success;
